// extracted by mini-css-extract-plugin
export default {"bestLines":"Stockfish_bestLines__InKP4","bestLine":"Stockfish_bestLine__gXVl7","bestMove":"Stockfish_bestMove__ePKkc"};